import {
	SET_FORM_STATE,
	TOGGLE_ADD_TICKET_DIALOG,
	GET_TICKET,
	TOGGLE_FILTERS,
	GET_TICKETS,
	GET_TEAMS_BY_TYPE,
	GET_ACTIVITIES,
	GET_TYPES,
	GET_STAGES
} from '../actions/TicketsActions.js';

const initialState = {
	tickets: [],
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	},
	openAddTicketDialog: false,
	teams: [],
	types: [],
	activities: [],
	stages: [],
	ticket: {
		details: {
			subject: '',
			teamId: 0,
			typeId: 0,
			stageId: 0,
			targetExecutionDate: ''
		},
		history: [],
		files: []
	},
	openFilters: false,
};

const techAddReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case TOGGLE_ADD_TICKET_DIALOG: {
						return {
							...state,
							openAddTicketDialog: action.openAddTicketDialog,
							formState: initialState.formState,
						};
					}
					case TOGGLE_FILTERS: {
						return {
							...state,
							openFilters: action.openFilters,
							formState: initialState.formState,
						};
					}
					case GET_TICKET: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.ticket }
							},
							ticket: {
								details: { ...action.ticket },
								comments: action.ticket.comments,
								files: action.ticket.attachedFiles,
								history: action.ticket.history
							}
						};
					}
					case GET_TICKETS: {
						return {
							...state,
							tickets: action.tickets

						};
					}
					case GET_TEAMS_BY_TYPE: {
						return {
							...state,
							teams: action.teams,
							formState: {
								...state.formState,
								values: { ...state.formState.values, teamId: parseInt(action.teams[0].value, 10) }
							},
						};
					}
					case GET_ACTIVITIES: {
						return {
							...state,
							activities: action.activities

						};
					}
					case GET_TYPES: {
						return {
							...state,
							types: action.types,
						};
					}
					case GET_STAGES: {
						return {
							...state,
							stages: action.stages,
						};
					}
					default: {
						return state;
					}
	}
};

export default techAddReducer;
